import blocks from 'src/js/modules/blocks';
import { CONTENT_SCALE_CSS_PROPERTY } from 'src/js/modules/extensions/registry/ws-image/constants/media-container';
import hasBackgroundContainer from './has-background-container';
import isImageContainer from './is-image-container';
import { getSettings } from '../settings';

const setScale = (node, scale) => {
  const settings = getSettings();

  if (blocks.verifiers.isWsBlock(node)) {
    node.setAttribute('background-scale', scale);
    const backgroundContainer = node.querySelector(settings.backgroundContainer);

    return backgroundContainer.calculateBoundsByScale(scale);
  }

  if (hasBackgroundContainer(node)) {
    const backgroundContainer = node.querySelector(settings.backgroundContainer);
    backgroundContainer.setAttribute('scale', scale);
    return backgroundContainer.calculateBoundsByScale(scale);
  }

  if (isImageContainer(node)) {
    node.style.setProperty(CONTENT_SCALE_CSS_PROPERTY, scale);
    // `ws-media-container` renders scale purely via CSS custom property and doesn't
    // dispatch `ws:resize` on its own, so we trigger it to keep focal point UI in sync
    node.renderMedia();
    return node.calculateBoundsByScale(scale);
  }
};

export default setScale;
